<template>
  <div id="app">
    <router-view/>
    <div class="scroll-bar" :style="'height: '+scrollHeight+'%;'"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import wx from 'weixin-js-sdk'
export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'scrollTop',
      'scrollHeight',
      'textInfo',
      'screenHeight'
    ])
  },
  watch: {
    textInfo (val) {
      if (val) {
        this.info = this.$.s2o(val)
      }
    },
    $route (val) {
      window.scroll(0, 0)
      setTimeout(() => {
        this.init()
        this.setScrollHeight()
        if (val.meta.title) {
          document.getElementsByTagName('title')[0].innerText = 'GEOHE几合_' + val.meta.title
        }
      }, 100)
    },
    scrollTop () {
      this.setScrollHeight()
    }
  },
  data () {
    return {
      info: {}
    }
  },
  mounted () {
    if (this.$.g('textInfo')) {
      this.info = this.$.s2o(this.$.g('textInfo'))
    }
    // 微信吊起分享，除各模块详情外使用固定分享内容，调用基本配置
    this.init()
    this.setScrollHeight()
  },
  methods: {
    setScrollHeight () {
      let height = document.getElementById('app').clientHeight
      let num = this.scrollTop / (height - this.screenHeight) * 100
      this.$store.commit('scrollToHeight', num)
    },
    /**
     * 初始化
     */
    init () {
      this.get({
        url: 'signatureRead',
        data: {
          url: window.location.href
        }
      }, res => {
        if (res.code) {
          let that = this
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: [
              'onMenuShareTimeline', // 分享到朋友圈
              'onMenuShareAppMessage' // 分享给朋友
            ]
          })
          wx.ready(function () {
            // 分享到朋友圈
            wx.onMenuShareTimeline({
              title: document.getElementsByTagName('title')[0].innerText, // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.$.o2s(that.info) === '{}' ? 'https://suisuixiang.oss-cn-beijing.aliyuncs.com/1521%2A%2A%2A%2Acom/2022-04-12/logo2.png' : that.info.share_logo, // 分享图标
              desc: that.$.o2s(that.info) === '{}' ? 'GEOHE几合是一家拥有八年服务经验的UI设计和网站开发机构。' : that.info.share_desc,
              success: function () {
              }
            })
            // 分享给朋友
            wx.onMenuShareAppMessage({
              title: document.getElementsByTagName('title')[0].innerText, // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.$.o2s(that.info) === '{}' ? 'https://suisuixiang.oss-cn-beijing.aliyuncs.com/1521%2A%2A%2A%2Acom/2022-04-12/logo2.png' : that.info.share_logo, // 分享图标
              desc: that.$.o2s(that.info) === '{}' ? 'GEOHE几合是一家拥有八年服务经验的UI设计和网站开发机构。' : that.info.share_desc,
              success: function () {
              }
            })
            wx.error(function (res) {
              console.log(res)
            })
          })
        }
      })
    }
  }
}
</script>
<style lang="less" src="./utils/main.less"></style>



// WEBPACK FOOTER //
// src/App.vue